import { ReactNode, useState } from 'react'

import { ChevronDownIcon, ChevronUpIcon, InformationCircleIcon } from '@heroicons/react/24/outline'

type InfoPanelProps = {
  title: string
  children: ReactNode
  defaultOpen?: boolean
}

export function InfoPanel({ title, children, defaultOpen = false }: InfoPanelProps) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="overflow-hidden rounded-lg border border-blue-200 bg-blue-50">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between px-4 py-3 text-left transition-colors hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <span className="flex items-center gap-2">
          <InformationCircleIcon className="h-5 w-5 text-blue-600" aria-hidden="true" />
          <span className="text-sm font-semibold text-blue-900">{title}</span>
        </span>
        {open ? <ChevronUpIcon className="h-5 w-5 text-blue-600" aria-hidden="true" /> : <ChevronDownIcon className="h-5 w-5 text-blue-600" aria-hidden="true" />}
      </button>
      {open && <div className="px-4 pb-4 text-sm text-blue-900">{children}</div>}
    </div>
  )
}
